import { type AsyncStorage, type MaybePromise, type Persister } from '@tanstack/svelte-query-persist-client';
import { browser } from '$app/env';
import localforage from 'localforage';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

let store: LocalForage;

if (browser) {
  store = localforage.createInstance({
    driver: [
      localforage.INDEXEDDB,
      localforage.WEBSQL,
      localforage.LOCALSTORAGE,
    ],
    name: 'gramjam',
    storeName: 'api',
  });
}

const asyncStorage = {
  getItem: async (key: string) => {
    if (browser) {
      return await store.getItem(key);
    }
  },
  setItem: async (key: string, value: string) => {
    if (browser) {
      return await store.setItem(key, value);
    }
  },
  removeItem: async (key: string) => {
    if (browser) {
      return await store.removeItem(key);
    }
  },
} as AsyncStorage;

export const asyncStoragePersister = createAsyncStoragePersister({
  storage: asyncStorage,
  throttleTime: 1000,
  serialize: (persistedQuery) =>
    persistedQuery as unknown as MaybePromise<string>,
  // @ts-ignore
  deserialize: (cached) => cached as unknown as MaybePromise<PersistedClient>,
}) as Persister;

